import React, { useState, useEffect,useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {customStyleSelect } from "utils/common";
import {  statusOptions} from "utils/constants";
import useUploadHook from "components/uploadHook";
import FilterSelect from "components/Form/filterSelect";
import {  toast, Bounce } from 'react-toastify';
import {Switch} from "antd";
import { useMediaQuery } from "react-responsive";

import { useSelector } from "react-redux";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button } from "components/Button";
import {format} from "date-fns"
import { useDropzone } from 'react-dropzone';

import { postDocumentApi, updateDocumentApi } from "api/services/documents";
import ViewDocumentAttachments from "views/pages/Documents/documentDetail/attachmentHandler";
import EssFullWidthModal from "components/modelpopup/baseModal"
import DateInput from "components/Form/dateInput"
const AllDocumentAddPopup = ({createDocumentHandler, documentModal, setDocumentModal, loading, selectedDocument, setLoading, setSelectedDocument, getDocumentList, documentTypeLoading, documentType,storeType}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);

  const modalRef = useRef()
  const [setSelectedOption] = useState(null);
  const [setSelectedOptionTwo] = useState(null);
  const [setSelectedOptionThree] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateTwo, setSelectedDateTwo] = useState(null);

  const [documentSubTypeOption, setDocumentSubTypeOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [storeOption, setStoreOption] = useState([]);

  // const [documentTypeOption, setDocumentTypeOption] = useState([{
  //   label:"User",
  //   value:"user"
  // }]);

  const [fileUploadLoading, setFileUploadLoading] = useState(false);

  
  const {
    documentSubType, documentSubTypeLoading,

    userData, userDataLoading,
    costCenter, costCenterLoading
   
} = useSelector((state) => state.common);

const {
  uploadLoading,
  handleFile
} = useUploadHook()
console.log(storeType, "DOCUMENT TYPE")

const documentSchema = Yup.object().shape({
  name: Yup.string().required('Document name is required'), 
  // description: Yup.string(), 

  issue_date: Yup.date().required("Issue date is required"),
  expiry_date: Yup.date().required("Expiry date is required").min(Yup.ref("issue_date"), "Expiry date must be later than issue date"),
  // expiry_notify_in_days: Yup.number(),
  document_type: Yup.object().required("Type is required"),
  // document_sub_type: Yup.object().required("Sub Type is required"),
  // company_user: Yup.object(),
  // .required("User is required"),
  company_user: storeType === 'user' 
  ? Yup.object().required("User is required")
  : Yup.mixed().nullable(),
  store: storeType === 'store' 
      ? Yup.object().required("Store is required") 
      : Yup.mixed().nullable(),
  status: Yup.boolean(),
  // .required("Status is required"),
  attachments: Yup.array()
  .of(
    Yup.object().shape({
      url: Yup.string()
        .url('Invalid URL')
        .required('URL is required'), // Validate URL field
    })
  )
  .test('attachment-count', 'The number of attachments should be at least ${attachment_count} attachments.', function (value) {
    const { attachment_count } = this.parent.document_type || {}; // Access the attachment_count from document_type
    if (attachment_count && value?.length < attachment_count) {
      return this.createError({
        message: `The number of attachments should be at least ${attachment_count} attachments.`,
      });
    }
    return true; // Validation passes
  }),

});



const {
  control,
  handleSubmit,
  formState: { errors },
  getValues,
  watch,
  setValue,
  setError,
  reset  ,
  trigger,
  register
} = useForm({
  resolver: yupResolver(documentSchema), 
  defaultValues: {
    // status:true
  },
});

const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
  control, // control props comes from useForm (optional: if you are using FormProvider)
  name: "attachments", // unique name for your Field Array
});


useEffect(()=>{
  if(costCenter){
    setStoreOption(costCenter.map(item=> {
      return{
        label: item.name,
        value: item.id
      }
    }))
  }
},[costCenter])
useEffect(()=>{
   
  if(documentSubType){
    let sub_types = documentSubType.map(item=> {
      return{
          label: item.display_name,
          value: item.name
      }
  })
  setDocumentSubTypeOption(sub_types)
  }


},[documentSubType])

useEffect(()=>{
   
  if(userData){
    let users = userData.map(item=> {
      return{
          label: `${item.first_name} ${item.last_name}`,
          value: item.id
      }
  })
  setUserOption(users)
  }


},[userData])


useEffect(()=>{
  console.log(selectedDocument, documentType,"(((((((((((((((((")

  if(selectedDocument?.id && documentType?.length){
    setValue("name", selectedDocument?.name)
    // setValue("description", selectedDocument?.description)
    setValue("attachments", selectedDocument?.attachments?.map(item=> {
      return {
        // id: item.id,
        item_id:item.id,
        url: item.url
      }
    }))

    if(selectedDocument?.company_user){
      setValue("company_user", userOption.find(item=> item.value == selectedDocument?.company_user?.id))

    }
    // if(selectedDocument?.document_sub_type){
    //   console.log(selectedDocument?.department?.id, documentSubTypeOption, "JJJJJJJJJJJJJJJJ")
    //   setValue("document_sub_type", documentSubTypeOption.find(item=> item.value == selectedDocument?.document_sub_type))

    // }

    if(selectedDocument?.document_type){
      console.log(selectedDocument?.department?.id, documentType, "JJJJJJJJJJJJJJJJ")
      setValue("document_type", documentType?.find(item=> item.id == selectedDocument?.document_type?.id))

    }
    if(selectedDocument?.status){
      setValue("status", selectedDocument?.status)
      // setValue("status", statusOptions.find(item=> item.value == selectedDocument?.status.toLowerCase()))

    }



    setValue("expiry_date", selectedDocument?.expiry_date||"")
    setValue("issue_date", selectedDocument?.issue_date||"")

    // setValue("application_count", selectedDocument?.application_count)


  }else{
    reset()
    setValue("name", "")

    let selectedUserOption = userOption.find(item=> item.value == user?.id)
    if(selectedUserOption){
      console.log(selectedUserOption, "SELECTEDDDDDDDDD")
      setValue("company_user", selectedUserOption)
    }

  }
},[selectedDocument, documentModal, documentSubTypeOption, userOption, documentType])

 
  const optionsTwo = [
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
    { value: "Internship", label: "Internship" },
    { value: "Temporary", label: "Temporary" },
    { value: "Remote", label: "Remote" },
    { value: "Others", label: "Others" },
  ];


  const [selectedIssueDate, setSelectedIssueDate] = useState(null);
  const [selectedExpiryDate, setSelectedExpiryDate] = useState(null);

  const handleIssueDateChange = (date) => {
    setSelectedIssueDate(date);
  };

  const handleExpiryDateChange = (date) => {
    setSelectedExpiryDate(date);
  };

  const fileUploadHandler = async(acceptedFiles , rejectedFiles , e ) => {
    console.log(e.target.files, "EEEE")
    let attachments = []
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
       attachments = urls.map(item=>{return{url: item}})
    }else{
      attachments.push({
        url:urls
      })
    }
    console.log(fields, "LLLL")

    setValue("attachments", [...fields,...attachments])
   }


  const  onSubmit = (formData) =>{
    console.log(formData, "LLLLL")
    let data = {...formData}
    if(storeType === 'user'){
      data['company_user'] = data?.company_user?.value
      data['store'] = null
    }else{
      data['store'] = data?.store?.value
      data['company_user'] = null
    }

    // data['company_user'] = data?.company_user?.value
    // data['document_sub_type'] = data?.document_sub_type?.value
    data['document_type'] = data?.document_type?.id

    let attachments_data = data?.attachments?.map(item=>{
      return{
        id: item.item_id||"",
        url: item.url
      }
    })
    data['attachments'] = attachments_data

    // reset()
    // data['department'] = data?.department?.value
    // data['status'] = data?.status?.value
    if(data.expiry_date){
      data['expiry_date'] = format(new Date(data.expiry_date), "yyyy-MM-dd")
    }
    if(data.issue_date){
      data['issue_date'] = format(new Date(data.issue_date), "yyyy-MM-dd")
    }
    setLoading(true)

    if(selectedDocument?.id){
      updateDocumentApi(selectedDocument?.id, data).then(response=>{
        setLoading(false)
  
        toast.success('Document updated!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setDocumentModal(false)
          setSelectedDocument("")
          // reset()
          // setValue("attachments", [])
          reset({
            name: "",
            issue_date: null,
            expiry_date: null,
            document_type: null,
            company_user: storeType === 'user' ? userOption.find(item => item.value === user?.id) : null,
            store: null,
            status: false,
            attachments: []
          })
    
          getDocumentList()
  
        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          toast.error('Failed to create document!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
       
      })

    }else{
      data['status'] = true
      postDocumentApi([data]).then(response=>{
        setLoading(false)
        
        getDocumentList()
  
        toast.success('Document created!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setDocumentModal(false)
          setSelectedDocument("")
          // reset()
          // setValue("attachments", [])
          reset({
            name: "",
            issue_date: null,
            expiry_date: null,
            document_type: null,
            company_user: storeType === 'user' ? userOption.find(item => item.value === user?.id) : null,
            store: null,
            status: false,
            attachments: []
          })
    
  
        console.log(response, "REEEEEE")
      }).catch(e=> {
        console.log(e, "eee")
        setLoading(false)
        try{
          console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
            setError(k,
              {
                type: 'manual',
                message: v.join(", ")
              }
               )
          })
        }
        }catch(e){
          toast.error('Failed to create document!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
        
      })
    }

   
    // createDocumentHandler(data, setError, modalRef, reset)
    // setError('status', { type: 'custom', message: 'custom message' });

    // setError("status", "status errrr")
  }
 

  const document_type = watch("document_type")

   // Use Dropzone hook
   const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,
    minFiles: document_type?.attachment_count,
    maxFiles: document_type?.attachment_count,
    accept: 'image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Accept image, PDF, DOCX
  });





  return (
    <>
      <div role="dialog">     
      <EssFullWidthModal
        mask={false}
              title={selectedDocument?.id ? "Update Document":"Add Document"}
              // style={{ top: 100 }}
              open={documentModal}
              width={"40%"}
              footer={[]}     
              onCancel={() => {
                // reset()
                reset({
                  name: "",
                  issue_date: null,
                  expiry_date: null,
                  document_type: null,
                  company_user: storeType === 'user' ? userOption.find(item => item.value === user?.id) : null,
                  store: null,
                  status: false,
                  attachments: []
                })
          
                setDocumentModal(false)
                setSelectedDocument("")
              }}
                className="full-width-modal"


            >
         
          <div className="modal-content" style={{ padding: 0 }}>
            <div className="modal-body" style={{ padding: isMobile ? "20px 16px" : "24px" }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row g-2">
                    {/* Document Name */}
                  <div className="col-md-6">
                    <div className="input-block" style={{ marginBottom: "16px" }}>
                      <label className="col-form-label" style={{ 
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "6px"
                      }}>
                        Document Name <span className="text-danger">*</span>
                      </label>
                       <Controller
                              name="name"
                              control={control}                      
                              render={({ field }) => (
                                <input 
                                  className="form-control"  
                                  value={field.value || ""}
                                onChange={(e) => field.onChange(e.target.value)}
                                type="text"
                                  placeholder="Enter document name"
                                  style={{
                                    padding: "10px 12px",
                                    borderRadius: "6px",
                                    border: errors.name ? "2px solid #ef4444" : "1px solid #d1d5db",
                                    fontSize: "14px",
                                    transition: "all 0.2s ease"
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = errors.name ? "#ef4444" : "rgb(211, 0, 26)";
                                    e.target.style.boxShadow = "0 0 0 3px rgba(211, 0, 26, 0.1)";
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = errors.name ? "#ef4444" : "#d1d5db";
                                    e.target.style.boxShadow = "none";
                                  }}
                                />                    
                         )}
                  />
                    {errors.name && (
                      <small className="text-danger" style={{ 
                        fontSize: "12px",
                        marginTop: "4px",
                        display: "block"
                      }}>
                        <i className="las la-exclamation-circle me-1"></i>
                        {errors.name?.message}
                      </small>
                    )}
                    </div>
                  </div>
                    {/* Description */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Description</label>
                      <Controller
                        name="description"
                        control={control}                      
                        render={({ field }) => (
                          <input className="form-control"  value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                          type="text"
                          placeholder="Description"
                          />
                    )}
                  />
           

                      
                    </div>
                  </div> */}
                </div>
                <div className="row g-2">
                    {/* Issue Date */}
                  <div className="col-md-6">
                    <div className="input-block" style={{ marginBottom: "16px" }}>
                      <label className="col-form-label" style={{ 
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "6px"
                      }}>
                        Issue Date <span className="text-danger">*</span>
                      </label>
                      <Controller
                          name="issue_date"
                          control={control}
                          render={({ field }) => (
                            <div style={{
                              border: errors.issue_date ? "2px solid #ef4444" : "1px solid #d1d5db",
                              borderRadius: "6px",
                              overflow: "hidden",
                              transition: "all 0.2s ease"
                            }}>
                            <DateInput
                              value={field?.value}
                              onChange={field.onChange}
                            />
                            </div>
                          )}
                        />
                        {errors.issue_date && (
                          <small className="text-danger" style={{ 
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block"
                          }}>
                            <i className="las la-exclamation-circle me-1"></i>
                            {errors.issue_date?.message}
                          </small>
                        )}       
                    </div>
                  </div>

                    {/* Expiry Date */}
                  <div className="col-md-6">
                    <div className="input-block" style={{ marginBottom: "16px" }}>
                      <label className="col-form-label" style={{ 
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "6px"
                      }}>
                        Expiry Date <span className="text-danger">*</span>
                      </label>
                      <Controller
                          name="expiry_date"
                          control={control}
                          render={({ field }) => (
                            <div style={{
                              border: errors.expiry_date ? "2px solid #ef4444" : "1px solid #d1d5db",
                              borderRadius: "6px",
                              overflow: "hidden",
                              transition: "all 0.2s ease"
                            }}>
                            <DateInput
                              value={field?.value}
                              onChange={field.onChange}
                            />
                            </div>
                          )}
                        />
                        {errors.expiry_date && (
                          <small className="text-danger" style={{ 
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block"
                          }}>
                            <i className="las la-exclamation-circle me-1"></i>
                            {errors.expiry_date?.message}
                          </small>
                        )}       
                    </div>
                  </div>

                 
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Notify Expiry in Days</label>
                      <Controller
                        name="expiry_notify_in_days"
                        control={control}
                        
                        render={({ field }) => (
                          <input className="form-control"  value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                          type="number"
                          placeholder="Notify Expiry in Days"
                />
               
              )}
            />
            {errors.expiry_notify_in_days && <small className="text-danger">{errors.expiry_notify_in_days?.message}</small>}

                    </div>
                  </div>  */}

                  {/* Select User */}
                                 
                  
                </div>
                
                
                <div className="row g-2">

                 {/* Document Type */}
                  <div className="col-md-6">
                  <div className="input-block" style={{ marginBottom: "16px" }}>
                      <label className="col-form-label" style={{ 
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "6px"
                      }}>
                        Document Type <span className="text-danger">*</span>
                      </label>
                      <Controller
                         name={`document_type`}                   
                         control={control}                  
                         render={({ field: { value, onChange } }) => (
                          <div style={{
                            border: errors.document_type ? "2px solid #ef4444" : "1px solid #d1d5db",
                            borderRadius: "6px",
                            overflow: "hidden"
                          }}>
                          <FilterSelect
                        {...register("document_type")}
                        isClearable={true}
                        onChange={(e)=>{
                          onChange(e);
                          if(!fields?.length){
                            setValue("attachments",[])
                          }
                          trigger()}
                        }
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={documentType}
                        isLoading={documentTypeLoading}
                        value={value}
                              placeholder={"Select document type"}
                        isDisabled={selectedDocument?.id}
                      />                       
                          </div>
                    )}
                  />
                  
                  {errors.document_type && (
                    <small className="text-danger" style={{ 
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      <i className="las la-exclamation-circle me-1"></i>
                      {errors.document_type?.message}
                    </small>
                  )}                     
                  </div>
                  </div>
                   {/* Company User - conditionally rendered */}
                   {storeType === "user" && (
                    <div className="col-md-6">
                      <div className="input-block" style={{ marginBottom: "16px" }}>
                        <label className="col-form-label" style={{ 
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#374151",
                          marginBottom: "6px"
                        }}>
                          Company User <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name={`company_user`}                   
                          control={control}                  
                          render={({ field: { value, onChange } }) => (
                            <div style={{
                              border: errors.company_user ? "2px solid #ef4444" : "1px solid #d1d5db",
                              borderRadius: "6px",
                              overflow: "hidden"
                            }}>
                            <FilterSelect
                              {...register("company_user")}
                              isClearable={true}
                              onChange={onChange}
                              optionLabel={"label"}
                              optionValue={"value"}
                              options={userOption}
                              isLoading={userDataLoading}
                              value={value}
                              isDisabled={selectedDocument?.id}
                                placeholder={"Select company user"}
                            />                        
                            </div>
                          )}
                        />
                        {errors.company_user && (
                          <small className="text-danger" style={{ 
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block"
                          }}>
                            <i className="las la-exclamation-circle me-1"></i>
                            {errors.company_user?.message}
                          </small>
                        )}                     
                      </div>
                    </div>
                  )}
                  
                  {/* Store - conditionally rendered */}
                  {storeType === "store" && (
                    <div className="col-md-6">
                      <div className="input-block" style={{ marginBottom: "16px" }}>
                        <label className="col-form-label" style={{ 
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#374151",
                          marginBottom: "6px"
                        }}>
                          Store <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name={`store`}                   
                          control={control}                  
                          render={({ field: { value, onChange } }) => (
                            <div style={{
                              border: errors.store ? "2px solid #ef4444" : "1px solid #d1d5db",
                              borderRadius: "6px",
                              overflow: "hidden"
                            }}>
                            <FilterSelect
                              {...register("store")}
                              isClearable={true}
                              onChange={onChange}
                              optionLabel={"label"}
                              optionValue={"value"}
                              options={storeOption}
                              isLoading={costCenterLoading}
                              value={value}
                              placeholder={"Select Store"}
                              isDisabled={selectedDocument?.id}
                            />                        
                            </div>
                          )}
                        />
                        {errors.store && (
                          <small className="text-danger" style={{ 
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block"
                          }}>
                            <i className="las la-exclamation-circle me-1"></i>
                            {errors.store?.message}
                          </small>
                        )}                     
                      </div>
                    </div>
                  )}
                  {/* <div className="col-md-6">
                  <div className="input-block mb-3">
                      <label className="col-form-label">Company User</label>
                      <Controller
                         name={`company_user`}                   
                         control={control}                  
                         render={({ field: { value, onChange } }) => (
                          <>
                           <FilterSelect
                        {...register("company_user")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={userOption}
                        isLoading={userDataLoading}
                        value={value}
                        placeholder={"Company user"}
                      />                        
                      </>
                    )}
                  />
                  {
                    console.log(errors, "EEEEEEEE")
                  }
                  {errors.company_user && <small className="text-danger">{errors.company_user?.message}</small>}                     
                  </div>
                  </div>  
                  */}
                  {/* Document Subtype */}
                  {/* <div className="col-md-6">
                  <div className="input-block mb-3">
                      <label className="col-form-label">Document Sub type</label>
                      <Controller
                         name={`document_sub_type`}                   
                         control={control}                   
                         render={({ field: { value, onChange } }) => (
                          <>
                          <FilterSelect
                        {...register("document_sub_type")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={documentSubTypeOption}
                        isLoading={documentSubTypeLoading}
                        value={value}
                        placeholder={"Document Sub type"}
                      />
                            
                          </>
                    )}
                  />
                  {
                    console.log(errors, "EEEEEEEE")
                  }
                   {errors.document_sub_type && <small className="text-danger">{errors.document_sub_type?.message}</small>}
                     
                    </div>
                  </div>                  */}
                </div>            
              
               {/* Attachments */}
               
                <div className="row g-2">
                  <div className={selectedDocument?.id ? "col-md-6" : "col-md-12"}>
                  <div className="input-block" style={{ marginBottom: "16px" }}>
                    <label className="col-form-label" style={{ 
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#374151",
                      marginBottom: "6px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px"
                    }}>
                      Attachments
                      {document_type?.attachment_count && (
                        <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: "400" }}>
                          ({document_type.attachment_count} required)
                        </span>
                      )}
                      {uploadLoading && <i className="fa fa-spinner fa-spin" style={{ fontSize: "12px" }}></i>}
                    </label>
                    
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: errors?.attachments ? '2px dashed #ef4444' : '2px dashed #d1d5db',
                        borderRadius: '8px',
                        padding: isMobile ? '16px' : '20px',
                        textAlign: 'center',
                        background: '#f9fafb',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = errors?.attachments ? '#ef4444' : 'rgb(211, 0, 26)';
                        e.currentTarget.style.background = '#f3f4f6';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = errors?.attachments ? '#ef4444' : '#d1d5db';
                        e.currentTarget.style.background = '#f9fafb';
                      }}
                    >
                      <input {...getInputProps()} />
                      <i className="fa-solid fa-cloud-arrow-up" style={{ 
                        fontSize: "32px", 
                        color: "#9ca3af",
                        marginBottom: "8px"
                      }}></i>
                      <p style={{ 
                        margin: 0, 
                        fontSize: "13px",
                        color: "#6b7280",
                        fontWeight: "500"
                      }}>
                        Drag & drop files here, or click to select
                      </p>
                      <p style={{ 
                        margin: 0, 
                        fontSize: "11px",
                        color: "#9ca3af"
                      }}>
                        Supports: Images, PDF, DOCX
                      </p>
                    </div>

                    {errors?.attachments && (
                      <small className="text-danger" style={{ 
                        fontSize: "12px",
                        marginTop: "4px",
                        display: "block"
                      }}>
                        <i className="las la-exclamation-circle me-1"></i>
                    {errors?.attachments?.message}
                      </small>
                    )}
                </div>
                  </div>

                    {selectedDocument?.id && (
                      <div className="col-md-6">
                        <div className="input-block" style={{ marginBottom: "16px" }}>
                          <label className="col-form-label" style={{ 
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "6px"
                          }}>
                            Status
                          </label>
                  <Controller
                          name="status"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                              <div className="d-flex align-items-center" style={{
                                background: "#f9fafb",
                                padding: "12px",
                                borderRadius: "6px",
                                border: "1px solid #e5e7eb"
                              }}>
                              <Switch 
                                checked={value} 
                                onChange={onChange} 
                                  checkedChildren="Active"
                                  unCheckedChildren="Inactive"
                                  style={{
                                    background: value ? "rgb(211, 0, 26)" : "#d1d5db"
                                  }}
                                />
                                <span className="ms-2" style={{ 
                                  fontSize: "13px",
                                  color: "#374151",
                                  fontWeight: "500"
                                }}>
                                  {value ? "Active" : "Inactive"}
                                </span>
                            </div>
                          )}
                        />
                    {errors.status && (
                            <small className="text-danger" style={{ 
                              fontSize: "12px",
                              marginTop: "4px",
                              display: "block"
                            }}>
                              <i className="las la-exclamation-circle me-1"></i>
                        {errors.status?.message}
                      </small>
                    )}
                  </div>
                  </div>
                    )}
                </div>

                {fields.length > 0 && (
                  <div className="row" style={{ marginTop: "8px" }}>
                    <div className="col-12">
                      <div style={{
                        background: "#f9fafb",
                        padding: "12px",
                        borderRadius: "6px",
                        border: "1px solid #e5e7eb"
                      }}>
                        <ViewDocumentAttachments fields={fields} remove={remove} />
                </div>
                </div>
                  </div>
                )}
                
                <div className="submit-section" style={{ 
                  marginTop: "20px",
                  paddingTop: "16px",
                  borderTop: "1px solid #e5e7eb",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px"
                }}>
                  <Button
                  loading={loading}
                  disabled={loading || uploadLoading}
                    className="btn"             
                    type="button"
                    label="Cancel"
                    onClick={() => {
                      reset({
                        name: "",
                        issue_date: null,
                        expiry_date: null,
                        document_type: null,
                        company_user: storeType === 'user' ? userOption.find(item => item.value === user?.id) : null,
                        store: null,
                        status: false,
                        attachments: []
                      });
                      setDocumentModal(false);
                      setSelectedDocument("");
                    }}
                    style={{
                      background: "#f3f4f6",
                      border: "1px solid #e5e7eb",
                      color: "#374151",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      fontWeight: "500"
                    }}
                  />
                  <Button
                    loading={loading}
                    disabled={loading || uploadLoading}
                    className="btn"             
                    type="submit"
                    label={selectedDocument?.id ? "Update Document" : "Add Document"}
                    style={{
                      background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      border: "none",
                      color: "#ffffff",
                      padding: "10px 24px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                      transition: "all 0.2s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(211, 0, 26, 0.2)";
                    }}
                  />
                </div>
              </form>
            </div>
          </div>
          </EssFullWidthModal> 
      </div>
    </>
  );
};

export default AllDocumentAddPopup;
